import { call, put, takeEvery } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'
import * as Constants from './constants'
import * as lsActions from './actions'
function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}
function handleFileRequest(request) {
  return request
    .then(function (response) {
      return response.data;
    })
    .catch((error) => { throw error })
}
function listNCCRequestApi(formData) {
  const request = axiosApi().post(
    Constants.LSNHAPKHO_LIST_NCC_API,
    formData
  )

  return handleRequest(request);
}
function* lsnhapkhoListNccRequestFlow(action) {
  //const nhaCungCap = yield select(getNhaCungCapState);
  try {
    const { formData } = action
    // grab the client from our action
    const results = yield call(listNCCRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(lsActions.lsnhapkhoListNhaCCSuccess(results.data))

  } catch (error) {
    yield put(lsActions.lsnhapkhoListNhaCCError(error))
  }
}
function listKhoRequestApi(formData) {
  const request = axiosApi().post(
    Constants.LSNHAPKHO_LIST_KHO_API,
    formData
  )

  return handleRequest(request);
}
function exportXlsRequestApi(formData) {
  let url = Constants.LSNHAPKHO_EXPORT_API + "?s=" + formData.store + "&kh=" + formData.khoId + "&ncc=" + formData.NhaCC + "&k=" + formData.keyword + "&tt=" + formData.trangThai + "&sd=" + formData.startDate + "&ed=" + formData.endDate;
  const request = axiosApi().get(
    url,
    {
      responseType: 'blob'
    }
  );

  return handleFileRequest(request);
}
function* lsnhapkhoExportXlsRequestFlow(action) {
  const { formData, callback } = action
  try {
    // grab the client from our action
    const results = yield call(exportXlsRequestApi, formData)
    // dispatch the action with our widgets!
    yield put(lsActions.lsnhapkhoExportXlsSuccess(results))
    if (typeof callback == 'function') {
      yield call(callback, results);
    }
  } catch (error) {
    yield put(lsActions.lsnhapkhoExportXlsError(error))
  }
}
function* lsnhapkhoListKhoRequestFlow(action) {
  //const nhaCungCap = yield select(getNhaCungCapState);
  try {
    const { formData } = action
    // grab the client from our action
    const results = yield call(listKhoRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(lsActions.lsnhapkhoListKhoSuccess(results.data))

  } catch (error) {
    yield put(lsActions.lsnhapkhoListKhoError(error))
  }
}

function listRequestApi(formData) {
  const request = axiosApi().post(
    Constants.LSNHAPKHO_LIST_API,
    formData
  )

  return handleRequest(request);
}
function* lsnhapkhoListRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData } = action
    const results = yield call(listRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(lsActions.lsnhapkhoListSuccess(results.data))

  } catch (error) {
    yield put(lsActions.lsnhapkhoListError(error))
  }
}
function lsnhapkhoItemRequestApi(formData) {
  const request = axiosApi().post(
    Constants.LSNHAPKHO_ITEM_API,
    formData
  )

  return handleRequest(request);
}
function* lsnhapkhoItemRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData } = action
    const results = yield call(lsnhapkhoItemRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(lsActions.lsnhapkhoItemSuccess(results.data))

  } catch (error) {
    yield put(lsActions.lsnhapkhoItemError(error))
  }
}
function lsnhapkhoPrintApi(formData) {
  const url = Constants.LSNHAPKHO_PRINT_API + "/" + formData.nhapid;
  const request = axiosApi().get(
    url,
    {
      responseType: 'blob'
    }
  );

  return handleFileRequest(request);
}

function* lsnhapkhoPrintRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData, callback } = action
    const results = yield call(lsnhapkhoPrintApi, formData)
    // dispatch the action with our widgets!
    yield put(lsActions.lsnhapkhoPrintSuccess(results))
  } catch (error) {
    yield put(lsActions.lsnhapkhoPrintError(error))
  }
}

function* lsnhapkhoWatcher() {
  yield [
    takeEvery(Constants.LSNHAPKHO_LIST_NCC_REQUESTING, lsnhapkhoListNccRequestFlow),
    takeEvery(Constants.LSNHAPKHO_LIST_KHO_REQUESTING, lsnhapkhoListKhoRequestFlow),
    takeEvery(Constants.LSNHAPKHO_LIST_REQUESTING, lsnhapkhoListRequestFlow),
    takeEvery(Constants.LSNHAPKHO_ITEM_REQUESTING, lsnhapkhoItemRequestFlow),
    takeEvery(Constants.LSNHAPKHO_PRINT_REQUESTING, lsnhapkhoPrintRequestFlow),
    takeEvery(Constants.LSNHAPKHO_EXPORT_XLS_REQUESTING, lsnhapkhoExportXlsRequestFlow),
  ]
}

export default lsnhapkhoWatcher



// WEBPACK FOOTER //
// ./src/views/LsNhapKho/sagas.js